<script>
import SniffStore from './SniffStore'

export default {
  props: {
    plotId: { type: String, required: true }
  },

  functional: true,

  render(h /*, { props, listeners } */) {
    const height = SniffStore.plotLineHeight
    const width = SniffStore.plotLineWidth

    const onMouseOver = (evt) => {
      let mouseX = evt.clientX - evt.currentTarget.getBoundingClientRect().x
      if (mouseX < 0) mouseX = null
      SniffStore.computeCaret(mouseX)
    }

    const onMouseLeave = (/*evt*/) => {
      SniffStore.computeCaret(null)
    }

    const result = h('div', {
      class: 'border-sparkline',
      style: { width: '100%' },
      on: {
        mousemove: onMouseOver,
        mouseleave: onMouseLeave
      },
      domProps: {
        innerHTML: `
        <svg
          class="bar-chart"
          width="${width}"
          height="${height}"
          shape-rendering="crispEdges"
        >
          <path
            class="area"
            shape-rendering="auto"
            fill="aliceblue"
            stroke="none"
          />
          <path
            class="line"
            shape-rendering="auto"
            fill="none"
            stroke="steelblue"
            stroke-width="1.5"
          />
          <g class="caret">
            <line x1="0" x2="0" y1="0" y2="30" />
          </g>
        </svg>
      `
      }
    })

    // SniffStore.plugZoomListener(result)

    return result
  }
}
</script>

<style lang="sass">
.caret
  line
    stroke: black
    stroke-width: 1px
    pointer-events: none
</style>
